import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export interface PublicNavItem {
  to: string;
  label: string;
}

export function usePublicNavItems(options: { videos?: boolean } = {}) {
  const { t } = useI18n();

  return computed<PublicNavItem[]>(() => [
    { to: '/', label: t('nav.home') },
    { to: '/galleries', label: t('nav.galleries') },
    ...(options.videos ? [{ to: '/videos', label: t('nav.videos') }] : []),
    { to: '/portfolio', label: t('nav.portfolio') },
    { to: '/contact', label: t('nav.contact') },
  ]);
}

export function usePublicUserMenuItems() {
  return computed(() => [
    { to: '/settings/profile', key: 'nav.my_profile' },
    { to: '/settings', key: 'nav.settings' },
    { to: '/my-account', key: 'nav.my_account' },
  ]);
}
